import script from "./Booking.vue?vue&type=script&setup=true&lang=js"
export * from "./Booking.vue?vue&type=script&setup=true&lang=js"

import "./Booking.vue?vue&type=style&index=0&id=6c29375c&scoped=true&lang=scss"
script.__scopeId = "data-v-6c29375c"

export default script